'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _support = require('helpers/support');

var _components = require('components');

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceByCampaignDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    REWARD_CAMPAIGN: state.voucher.REWARD_CAMPAIGN
  };
}, {
  getRewardCampaign: vouchersAction.getRewardCampaign
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceByCampaignDetail, _Component);

  function ServiceByCampaignDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ServiceByCampaignDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ServiceByCampaignDetail.__proto__ || (0, _getPrototypeOf2.default)(ServiceByCampaignDetail)).call.apply(_ref, [this].concat(args))), _this), _this.toService = function (appLink) {
      if (!!appLink) {
        window.open(appLink);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ServiceByCampaignDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var campaignHandle = this.props.params.campaignHandle;

      if (campaignHandle) {
        this.props.getRewardCampaign(campaignHandle);
      }
    }
  }, {
    key: 'renderAllReward',
    value: function renderAllReward(item) {
      var _this2 = this;

      var userNo = this.userNo;

      var _item = _support.Helper.parsePackageServiceToCard(item);
      if (_item.forRank && _item.forRank.type && userNo !== -1) {
        var campaignNo = _support.Helper.rankNo(_item.forRank.type);
        _item.allowExchange = userNo >= campaignNo;
      }
      return _react2.default.createElement(_components.RewardItem, {
        key: 'rewardItem_' + _item.packId,
        item: _item,
        redeemBtnText: 'Chi tiết',
        onPress: function onPress() {
          return _this2.toService(_item.service.appLink);
        },
        onExchange: function onExchange(e) {
          e.stopPropagation();
          _this2.toService(_item.service.appLink);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./ServiceByCampaign.scss');
      var _props$REWARD_CAMPAIG = this.props.REWARD_CAMPAIGN,
          loading = _props$REWARD_CAMPAIG.loading,
          data = _props$REWARD_CAMPAIG.data;

      var campaignName = data && data.length ? data[0].campaign.name : 'Ưu Đãi Gói';
      return _react2.default.createElement(
        'div',
        { className: styles.allReward },
        _react2.default.createElement(_reactHelmet2.default, { title: campaignName }),
        _react2.default.createElement(
          'div',
          { className: styles.listVoucher },
          !!(data && data.length) && data.map(function (item) {
            return _this3.renderAllReward(item);
          }),
          !!(!loading && data && data.length === 0) && _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Hi\u1EC7n t\u1EA1i ch\u01B0a c\xF3 khuy\u1EBFn m\xE3i n\xE0o!'
          )
        )
      );
    }
  }]);
  return ServiceByCampaignDetail;
}(_react.Component), _class2.propTypes = {
  // @data
  params: _react.PropTypes.object,
  history: _react.PropTypes.object,
  REWARD_CAMPAIGN: _react.PropTypes.object,
  // @action
  getRewardCampaign: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = ServiceByCampaignDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Service/ServiceByCampaignDetail.js
// module id = 1635
// module chunks = 0